import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import SortDropdown from "./SortDropdown";
import ViewToggle from "./ViewToggle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getAllProductsService } from "redux/services/general_service";

const ProductListHeader = ({
  totalProducts,
  currentSort,
  onSortChange,
  viewMode,
  onViewModeChange,
  onOpenFilters,
  searchQuery,
  selectedCategory,
  loading,
  handleSearch,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState(""); // إذا لم يكن موجود

  const formatProductCount = (count) => {
    return count;
  };

  const getHeaderTitle = () => {
    if (searchQuery) {
      return `${t("searchResultsFor")} "${searchQuery}"`;
    }
    if (selectedCategory) {
      const categoryLabels = {
        electronics: t("electronics"),
        clothing: t("clothing"),
        home: t("home"),
        beauty: t("beauty"),
        sports: t("sports"),
        books: t("books"),
        toys: t("toys"),
        automotive: t("automotive"),
      };
      return categoryLabels[selectedCategory] || t("products");
    }
    return t("allProducts");
  };

  const getHeaderSubtitle = () => {
    if (loading) {
      return t("loadingProducts");
    }
    if (totalProducts === 0) {
      return t("noProductsFound");
    }
    if (totalProducts === 1) {
      return t("oneProductFound");
    }
    return `${formatProductCount(totalProducts)} ${t("productsFound")}`;
  };

  return (
    <div className="bg-surface border-b border-border sticky top-16 z-40">
      <div className="px-4 py-4">
        {/* Header Title */}
        <div className="mb-4 text-right">
          <h1 className="text-2xl font-semibold text-text-primary mb-1">
            {getHeaderTitle()}
          </h1>
          <p className="text-text-secondary">{getHeaderSubtitle()}</p>
        </div>

        <div className="mb-4">
          <div className="relative flex items-center bg-white border border-gray-300 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
            <input
              type="text"
              // value={searchInput}
              onChange={(e) => {
                handleSearch(e.target.value);
                //setSearchInput()
                //   dispatch(getAllProductsService({ search: e.target.value }));
              }}
              //  onKeyPress={handleKeyPress}
              placeholder="ابحث عن المنتجات..."
              className="flex-1 px-4 py-2 text-sm text-gray-700 placeholder-gray-400 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={(e) => {
                console.log(e.target.value);
                //setSearchInput()
                dispatch(getAllProductsService({ search: e.target.value }));
              }}
              className="px-4 py-2 bg-global-1 text-white rounded-r-lg hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center"
            >
              <Icon name="Search" size={16} />
            </button>
          </div>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-between gap-4">
          {/* Left Side - Mobile Filter Button */}
          <div className="flex items-center space-x-3">
            <Button
              variant="outline"
              size="sm"
              onClick={onOpenFilters}
              iconName="Filter"
              iconPosition="left"
              className="lg:hidden"
            >
              {t("filters")}
            </Button>

            {/* Results Count - Desktop Only */}
            <div className="hidden lg:flex items-center space-x-2 text-sm text-text-secondary">
              <Icon name="Package" size={16} />
              <span>
                {loading
                  ? t("loading")
                  : `${formatProductCount(totalProducts)} ${t("results")}`}
              </span>
            </div>
          </div>

          {/* Right Side - Sort and View Controls */}
          <div className="flex items-center space-x-3">
            {/* View Toggle - Desktop Only */}
            <div className="hidden md:block">
              <ViewToggle
                viewMode={viewMode}
                onViewModeChange={onViewModeChange}
              />
            </div>

            {/* Sort Dropdown */}
            <SortDropdown
              currentSort={currentSort}
              onSortChange={onSortChange}
            />
          </div>
        </div>

        {/* Mobile View Toggle */}
        <div className="md:hidden mt-3 flex justify-center">
          <ViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
        </div>
      </div>
    </div>
  );
};

export default ProductListHeader;
